<template>
  <div class="page">
    <div class="top">
      <search />
    </div>

  </div>
</template>

<script>
import search from "./Search"
export default {
  name: "SearchPage",
  components: {search}
}


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/Searchpage.vue